import { VFC } from 'react'
import { RequestBoxCompany } from 'src/models/RequestBox'
import { Counter } from 'src/models/Room'
import { fontWeightMedium } from 'src/styles/font'
import styled, { css } from 'styled-components'
import {
  accentColor,
  lightgray,
  truewhite,
  _menuicon,
  _messagebg,
  _messagesbg,
  black,
} from 'src/styles/colors'
import { flexCenter } from 'src/styles/mixins'
import { LargeButton } from 'src/elements/Button'

export { RequestBoxForm }

export type RequestBoxFormProps = {
  requestBox: RequestBoxCompany
  sender: Counter
  onInterested: () => Promise<void>
  onNotInterested: () => Promise<void>
  isHidden?: boolean
  className?: string
}

const RequestBoxFormComponent: VFC<RequestBoxFormProps> = ({
  requestBox,
  sender,
  onInterested,
  onNotInterested,
  isHidden,
  className,
}) => {
  if (
    requestBox.companyId !== sender?.id ||
    requestBox.status === 'matched' ||
    requestBox.status === 'sended'
  )
    return <></>
  const isMyRequest = requestBox.companyId !== sender?.id
  return (
    <>
      <RequestBoxFormDiv className={className}>
        <p>この会員のつながり申請を承認しますか</p>

        {!isMyRequest &&
          (requestBox.status === 'request' ||
            requestBox.status === 'be_rejected' ||
            requestBox.status === 'not_interest') && (
            <Buttons>
              <DeniedButton disabled={isHidden} onClick={onNotInterested}>
                非承認
              </DeniedButton>
              <ApproveButton disabled={isHidden} onClick={onInterested}>
                承認
              </ApproveButton>
            </Buttons>
          )}
      </RequestBoxFormDiv>
    </>
  )
}
const RequestBoxForm = styled(RequestBoxFormComponent)``

const Buttons = styled.div`
  display: flex;
  gap: 24px;
  color: ${truewhite};
  ${flexCenter};
`

const styleHover = css`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -40px);
  display: block;
  background: ${black};
  font-size: 10px;
  border-radius: 4px;
  padding: 8px 12px;
  z-index: 1;
  line-height: 150%;
`

const ApproveButton = styled(LargeButton)`
  background: ${accentColor};
  color: ${truewhite};
  position: relative;
  padding: 10px 0;
  width: 200px;
  margin: 0 32px;
  :hover {
    ::after {
      content: '「承認」を押すとメッセージのやり取りが可能になります';
      ${styleHover};
    }
  }
`

const DeniedButton = styled(LargeButton)`
  background: ${lightgray};
  color: ${truewhite};
  position: relative;
  padding: 10px 0;
  width: 200px;
  margin: 0 32px;
  :hover {
    ::after {
      content: '「非承認」を押した事は相手には通知されません';
      ${styleHover};
    }
  }
`

const RequestBoxFormDiv = styled.div`
  font-size: 14px;
  font-weight: ${fontWeightMedium};
  padding: 32px 16px 48px;
  background: ${_messagebg};
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 12px;
  p {
    color: ${_menuicon};
  }
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
`
